module.exports = __webpack_public_path__ + "static/media/story-13.5dae6308.jpg";